import { computed, type Ref } from 'vue';
import { numberFormatter } from '@/modules/common/utils/formatters.ts';

export function useMaxLength(
  model: Ref<string>,
  maxLength: Ref<number | undefined>,
  formatToLocaleNumber?: Ref<boolean>,
) {
  const gradient = computed(() => {
    if (!maxLength.value) return { start: '0%', end: '0%' };
    const length = formatToLocaleNumber?.value ? model.value.replace(/\s/g, '').length : model.value.length;
    const start = (length / maxLength.value) * 100;
    const end = start > 0 ? Math.min(start + 5, 100) : 0;
    return { start: `${start}%`, end: `${end}%` };
  });

  function onInput(event: Event) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    let value = target.value;
    const maxLengthValue = maxLength.value;

    if (formatToLocaleNumber?.value) {
      const isNegative = value.trim().startsWith('-');
      let digitsOnly = value.replace(/\D/g, '');
      const totalLength = digitsOnly.length + (isNegative ? 1 : 0);
      if (maxLengthValue && totalLength > maxLengthValue) {
        digitsOnly = digitsOnly.slice(0, maxLengthValue - (isNegative ? 1 : 0));
      }
      const numericValue = isNegative ? `-${digitsOnly}` : digitsOnly;
      value = digitsOnly ? numberFormatter.format(+numericValue) : isNegative ? '-' : '';
    } else if (maxLengthValue && value.length > maxLengthValue) {
      value = value.slice(0, maxLengthValue);
    }

    model.value = value;
    target.value = value;
  }

  return { gradient, onInput };
}
